
import { defineComponent } from "vue";
import LargeHeading from "@/views/shared/common/LargeHeading.vue";
import { ContactFormInputData } from "@/views/contact-form/ContactForm.vue";
import {
  CONTACT_FORM_FORM_DATA_DEFAULT,
  CONTACT_REASON_OPTIONS,
} from "@/views/contact-form/ContactFormInput.vue";

export default defineComponent({
  name: "ContactFormCheck",
  components: {
    LargeHeading,
  },
  props: {
    formData: {
      type: Object as () => ContactFormInputData,
      default: () => {
        return { ...CONTACT_FORM_FORM_DATA_DEFAULT };
      },
      required: true,
    },
    errorMessage: {
      type: String,
      required: true,
    },
  },
  methods: {
    getContactReasonNameByCode(code: string): string {
      const result = CONTACT_REASON_OPTIONS.find(
        (option) => option.value === code
      );
      return result?.label ? result.label : "";
    },
    onCheckOut(): void {
      const params: ContactFormInputData = { ...this.formData };
      params.inquiry_type = this.getContactReasonNameByCode(
        this.formData.inquiry_type
      );
      this.$emit("checkOut", params);
    },
    onBackToInput(): void {
      this.$emit("backToInput");
    },
  },
  emits: ["checkOut", "backToInput"],
});
